export const NAME = 'dailyquiz';
